/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Mode_Hint_GpInputs */



/**
* | output |
* | --- |
* | "Points per event by placement: winner 25, other finalists 15, then 10, 9, 8… down the standings (Grand Prix style)." |
*
* @param {League_Mode_Hint_GpInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_mode_hint_gp = /** @type {((inputs?: League_Mode_Hint_GpInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Mode_Hint_GpInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Points par tournoi selon la place : vainqueur 25, autres finalistes 15, puis 10, 9, 8… en descendant le classement (façon Grand Prix).")
	if (locale === "es") return /** @type {LocalizedString} */ ("Puntos por torneo según la posición: ganador 25, otros finalistas 15, luego 10, 9, 8… bajando por la clasificación (estilo Grand Prix).")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Pontos por torneio conforme a colocação: vencedor 25, outros finalistas 15, depois 10, 9, 8… descendo a classificação (estilo Grand Prix).")
	if (locale === "it") return /** @type {LocalizedString} */ ("Punti per torneo in base al piazzamento: vincitore 25, altri finalisti 15, poi 10, 9, 8… scendendo in classifica (stile Grand Prix).")
	return /** @type {LocalizedString} */ ("Points per event by placement: winner 25, other finalists 15, then 10, 9, 8… down the standings (Grand Prix style).")
});